<div id="carousel2" class="carousel slide carousel-fade hero-carousel">

  <div class="carousel-inner">
    <div
      class="carousel-item"
      *ngFor="let slide of slides; let i = index; trackBy: trackByIndex"
      [class.active]="i === 0"
    >
      <!-- Background Image -->
      <div
        class="hero-bg"
        [ngStyle]="{ 'background-image': 'url(' + slide.imageUrl + ')' }"
      ></div>

      <!-- Curved Blur Overlay -->
<div class="curve-overlay">

  <!-- SVG defines the clip shape -->
  <svg width="0" height="0">
    <defs>
      <clipPath id="waveClip" clipPathUnits="objectBoundingBox">
        <path d="M0,0 H1 V0.65 
                 C0.85,0.9 0.7,0.55 0.55,0.7 
                 C0.4,0.85 0.25,0.6 0.1,0.75 
                 C0.05,0.8 0.02,0.72 0,0.7 Z" />
      </clipPath>
    </defs>
  </svg>

  <!-- THIS is the blur, now clipped -->
  <div class="blur-bg"></div>

</div>
      <!-- Content -->
      <div class="hero-content">
        <h1 class="hero-title">
          {{ slide.title }}
        </h1>
        <p class="hero-subtitle">
          {{ slide.description }}
        </p>
      </div>

    </div>
  </div>

</div>